exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sales-distribution-report-table[data-v-1dc2fd60]{width:100%}", ""]);

// exports
